import { render } from "./OverviewDeathSideNav.vue?vue&type=template&id=efcbf814"
import script from "./OverviewDeathSideNav.vue?vue&type=script&lang=js"
export * from "./OverviewDeathSideNav.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__